import React from 'react';
import ShortStatusContent from './ShortStatusContet';
import { ISystem } from '../../helpers/interfaces';

interface IShortStatusProps {
	system: ISystem;
	linkDisabled: boolean;
	showBigWeatherCard?: boolean;
	showSmallWeatherCard?: boolean;
	showSystemDocumentation?: boolean;
	showRainstormMode?: boolean;
	showServiceMode?: boolean;
	showTestNotication?: boolean;
	showW2Website?: boolean;
	showSystemGraph?: boolean;
	showResetSensorErrors?: boolean;
	systemFiles?: any;
	showNotifications: boolean;
}

class ShortStatus extends React.Component<IShortStatusProps> {
	render() {
		return (
			<ShortStatusContent 
				system={this.props.system}
				systemFiles={this.props.systemFiles}
				linkDisabled={this.props.linkDisabled}
				showBigWeatherCard={this.props.showBigWeatherCard}
				showSmallWeatherCard={this.props.showSmallWeatherCard}
				showSystemDocumentation={this.props.showSystemDocumentation}
				showRainstormMode={this.props.showRainstormMode}
				showServiceMode={this.props.showServiceMode}
				showTestNotication={this.props.showTestNotication}
				showW2Website={this.props.showW2Website}
				showSystemGraph={this.props.showSystemGraph}
				showResetSensorErrors={this.props.showResetSensorErrors}
				showNotifications={this.props.showNotifications}
			/>
		);
	}
}

export default ShortStatus;
